import { isObject } from '@pct-ts/typeguard';
import type { DialogMessageOptions } from './message-options';

export function isDialogMessageOptions(msg: unknown): msg is DialogMessageOptions {
  return isObject(msg) && 'type' in msg && msg.type === 'DIALOG';
}
